import { devLog } from '../../../core/utils/logging.js';

export const HIGHLIGHT_NAME = 'strato-typography-highlight';
let sharedHighlight: Set<AbstractRange> | Highlight | null = null;

/**
 * Gets or creates the shared text highlight.
 * All Highlight components share the same highlight instance.
 * @internal
 */
export function getOrCreateSharedHighlight(): Set<AbstractRange> | Highlight {
  if (sharedHighlight) {
    return sharedHighlight;
  }

  if ('Highlight' in window) {
    sharedHighlight = new Highlight();
    if (sharedHighlight instanceof Highlight) {
      CSS.highlights.set(HIGHLIGHT_NAME, sharedHighlight);
    }
  } else {
    // Fallback for browsers without CSS Highlight API support
    sharedHighlight = new Set();
    devLog(
      'CSS Highlight API is not supported in this browser. Text highlighting will not be visible.',
    );
  }

  return sharedHighlight;
}
